module.exports = __webpack_public_path__ + "static/media/logo_frewie.a085b07a.png";